import axios from '../../../HttpRequests/axios';
import handleException from '../../../Core/Helpers/handleException';

export const FETCH_BASIC_DASHBOARD_DATA_REQUEST = 'FETCH_BASIC_DASHBOARD_DATA_REQUEST';
export const FETCH_BASIC_DASHBOARD_DATA_SUCCESS = 'FETCH_BASIC_DASHBOARD_DATA_SUCCESS';
export const FETCH_BASIC_DASHBOARD_DATA_FAILURE = 'FETCH_BASIC_DASHBOARD_DATA_FAILURE';

export default () => async (dispatch) => {
  dispatch({ type: FETCH_BASIC_DASHBOARD_DATA_REQUEST });

  try {
    const response = await axios.get('dashboard/basic');
    
    console.log('Basic Dashboard Data Response:', response.data);
    
    dispatch({
      type: FETCH_BASIC_DASHBOARD_DATA_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.error('Basic Dashboard Error:', error);
    console.error('Error Response:', error.response);
    
    handleException(error);
    
    dispatch({
      type: FETCH_BASIC_DASHBOARD_DATA_FAILURE,
      payload: error.response ? error.response.data : error.message,
    });
  }
};
